import React, { createContext, useState, useContext } from 'react';

type Language = {
  code: string;
  name: string;
};

type LanguageContextType = {
  currentLanguage: Language | null;
  languages: Language[];
  setLanguage: (language: Language) => void;
};

const defaultLanguages: Language[] = [
  { code: 'english', name: 'English' },
  // { code: 'yoruba', name: 'Yorùbá' },
  { code: 'hausa', name: 'Hausa' },
  // { code: 'igbo', name: 'Igbo' },
];


const LanguageContext = createContext<LanguageContextType>({
  currentLanguage: null,
  languages: defaultLanguages,
  setLanguage: () => {},
});

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Try to get the saved language from localStorage
  const [currentLanguage, setCurrentLanguage] = useState<Language | null>(() => {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    return savedLanguage === null ? null : JSON.parse(savedLanguage);
  });

  const setLanguage = (language: Language) => {
    setCurrentLanguage(language);
    localStorage.setItem('selectedLanguage', JSON.stringify(language));
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        languages: defaultLanguages,
        setLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);